export interface Citation {
  url: string;
  title: string;
  accessedAt: string;
}

interface CitationsListProps {
  citations?: Citation[];
}

const extractHost = (url: string): string => {
  try {
    return new URL(url).host;
  } catch {
    return url;
  }
};

export const CitationsList = ({ citations }: CitationsListProps) => {
  if (!citations || citations.length === 0) return null;

  return (
    <section className="space-y-3">
      <h3 className="text-sm font-semibold">Fontes</h3>
      <p className="text-xs text-slate-500">
        Research que gerou esse draft. Use como referência, não cite no texto.
      </p>
      <ul className="space-y-2">
        {citations.map((c) => (
          <li key={c.url}>
            <a
              href={c.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block border border-slate-200 rounded-lg p-3 hover:bg-slate-50 transition-colors"
            >
              <div className="text-sm font-medium text-slate-900 line-clamp-2">{c.title}</div>
              <div className="text-xs text-slate-500 mt-1">{extractHost(c.url)}</div>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};
